import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <AppSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <TopicsSection />
        <UpdatesSection />
        <ContactSection />
        <CommentsSection />
        <RankingSection />
        <MediaSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}